import dayjs from "dayjs";

export const paths = {
  home: "/",
  login: "/login",
  register: "/auth/register",
  trading: "/trading",
  // old pages, redirect to trading
  strategies: "/strategies",
  openPositions: "/open-positions",
  tradesHistory: "/trades-history",
  ai: "/ai",
  aiNew: "/ai-new",
  strategiesExplorer: "/strategies-explorer",
  createModel: "/create-model",
  admin: "/admin",
  symbolsManagement: "/admin/symbols-management",
  usersManagement: "/admin/users-management",
  systemControl: "/admin/system-control",
  editTrades: "/admin/edit-trades",
  savePredictions: "/admin/save-predictions",
  recentTasks: "/admin/tasks",
  splits: "/admin/splits",
  fillQuality: "/admin/fill-quality",
  userSettings: "/settings",
  automation: "/automation",
  strategy: "/strategy",
  agent: "/agent",
  optionSimulator: "/option-simulator",
  optionsAnalysis: "/options-analysis",
  optionsLeaderboard: "/options-leaderboard",
  // old Watchlist and Options Strategies pages, redirect to trading (options)
  watchlist: "/watchlist",
  optionsStrategies: "/options-strategies",
};

export const rangePresets = [
  {
    label: "Today",
    value: [dayjs().add(-1, "d"), dayjs()],
  },
  {
    label: "Last Week",
    value: [dayjs().add(-7, "d"), dayjs()],
  },
  {
    label: "Last 2 Weeks",
    value: [dayjs().add(-14, "d"), dayjs()],
  },
  {
    label: "Last Month",
    value: [dayjs().add(-1, "M"), dayjs()],
  },
  {
    label: "Last 3 Months",
    value: [dayjs().add(-3, "M"), dayjs()],
  },
  {
    label: "Last 6 Months",
    value: [dayjs().add(-6, "M"), dayjs()],
  },
  {
    label: "Last Year",
    value: [dayjs().add(-1, "y"), dayjs()],
  },
];

export const modelSearchRangePresets = [
  {
    label: "Last 3 months",
    value: [dayjs().add(-3, "M"), dayjs()],
  },
  {
    label: "Last Year",
    value: [dayjs().add(-1, "y"), dayjs()],
  },
  {
    label: "Last 2 Year",
    value: [dayjs().add(-2, "y"), dayjs()],
  },
  {
    label: "Last 3 Year",
    value: [dayjs().add(-3, "y"), dayjs()],
  },
];

export const modelTrainingChannel = "training";
